<template>
  <div v-if="isOpen">
    <modal
      :title="`${$t('OrderInfo.modal.modification')} ${historyKey}`"
      key="modDeliModal"
      @close-request="closeModal()"
      closable
    >
      <div class="mx-3 mt-3">
        <div class="my-3 dispatch-info-tab">
          <div class="w-100 mr-2">
            <regular-input
            :id="`ref${orderId}`"
            :value="order.numRef"
            @input="order.numRef = $event"
            type="text" :placeholder="$t('OrderInfo.modal.reference')" class=""/>
          </div>

          <div class="w-100 dispatch-info-tab">
            <hover-tool-tip
              v-show="isBrunoAccount"
              class="pt-2 pl-2 pr-1"
              :text="$t('OrderCurrent.modal.dispatch.price_tooltip') + ' (' + (calculateMaxInputPrice(order)) + '$)'"
              :right="true"
              :bottom="true"
              :clickable="false"
            />
            <regular-input-number
            v-show="!isBrunoAccount"
            :id="`price${orderId}`"
            :value="order.price"
            @input="order.price = $event"
            type="number" :placeholder="$t('OrderInfo.modal.price')" class="w-100"/>
            <regular-input-number
            v-show="isBrunoAccount"
            :id="`price${orderId}`"
            :value="order.price"
            @input="order.price = $event"
            type="number" :placeholder="(calculateMaxInputPrice(order)) + '$ Max'" class="w-100"/>
          </div>
        </div>
        <div class="my-3 dispatch-info-tab"> 
          <div class="w-100 mr-2">
            <regular-input
            :id="`bill${orderId}`"
            :value="order.numBill"
            @input="order.numBill = $event"
            type="text" :placeholder="$t('HistoryPage.bill_number')" class=""/>
          </div>
        </div>
        <regular-text-area
        :id="`comment${orderId}`"
        :value="order.comment"
        @input="order.comment = $event"
        :placeholder="$t('OrderInfo.modal.comment')" class="form-group" rows="6"/>
        <p class="red-text mb-0">{{feedbackMessage}}</p>
        <div class="row">
          <div class="col-12 col-sm-6">
            <button class="btn btn-kne-orange w-100 mb-3" @click="onSaveDeliveryAction(order)">{{$t('OrderInfo.modal.save')}}</button>
          </div>
          <div class="col-12 col-sm-6">
            <a v-if="deliveryInvoice" :href="deliveryInvoice" target="_blank">
              <button class="btn btn-kne-orange w-100 mb-3">{{$t('OrderInfo.modal.purchase')}}</button>
            </a>
            <a v-else>
              <button class="btn btn-kne-red w-100 mb-3">{{$t('ModificationDeliveryModal.purchase_not_found')}}</button>
            </a>
          </div>

          <div class="col-12 col-sm-6">
            <button class="btn btn-kne-orange w-100 mb-3" @click="onResendConfirmationEmail()">{{$t('OrderInfo.modal.resend')}}</button>
          </div>
          <div class="col-12 col-sm-6">
            <button class="btn btn-kne-orange w-100 mb-3" @click="onRegenerateInvoice()">{{$t('OrderInfo.modal.regenerate')}}</button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { db, dbArchives2 } from '../../../../firebase.js'
import RegularTextArea from '../../basic-components/regularTextarea.vue'
import RegularInput from '../../basic-components/regularInput.vue'
import RegularInputNumber from '../../basic-components/regularInputNumber.vue'
import HoverToolTip from '../../basic-components/HoverToolTip.vue'
import Modal from '../../interface-components/Modal.vue'

export default {
  name: 'ModificationDeliveryModal',

  components: {
    RegularTextArea,
    RegularInput,
    RegularInputNumber,
    HoverToolTip,
    Modal
  },

  data () {
    return {
      feedbackMessage: '',
      order: {}
    }
  },

  props: {
    // order: {
    //   type: Object,
    //   required: true
    // },
    orderId: String,
    entry: Object,
    historyKey: String,
    isOpen: Boolean,
    priceOrderLink: Array,
    isSetCssFeedback: {
      type: Boolean,
      default: true
    },
    isOrderArchived: {
      type: Boolean,
      default: false
    }
  },

  created () {
    this.setData()
  },

  methods: {
    /** Calculates the price the user can input in the price field (Order price - all previous dispatch prices) */
    calculateMaxInputPrice (order) {
      let orderNumber = (order.orderNumber) ? order.orderNumber : this.orderId
      let currentOrder = this.priceOrderLink.find(obj => obj.orderId === orderNumber)
      const history = order.historySync
      let orderMaxPrice = Number(currentOrder.price)

      for (const historyId in history) {
        if (Object.hasOwnProperty.call(history, historyId)) {
          const historyInfo = history[historyId]
          orderMaxPrice = orderMaxPrice - Number(historyInfo.price || historyInfo.prix || 0)
        }
      }

      return orderMaxPrice || 0
    },

    setData () {
      this.order.numRef = this.entry.numRef || ''
      this.order.price = this.entry.price || this.entry.prix || 0
      this.order.comment = this.entry.comment || ''
      this.order.numBill = this.entry.numBill || ''
    },

    onSaveDeliveryAction (order) {
      if (this.isBrunoAccount) {
        if (!this.checkDispatchPrice()) return
      }

      if (this.checkIsUndefined(order.price) && this.checkIsUndefined(order.prix)) order.price = 0

      this.returnDbPath.update({
        numRef: order.numRef,
        price: order.price,
        comment: order.comment,
        numBill: order.numBill
      }).then(() => {
        // ======================== ADD MODIFY HISTORY LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.orderId, 'numRef': order.numRef, 'action': 'MODIFY_ORDER_HISTORY', 'date': Date.now()})
      })

      this.$emit('onOrderModification', order)
      this.reinitializeData()
    },

    checkDispatchPrice (newPrice) {
      let index = 0
      let isAllGood = true
      let tempState = true

      const currentOrder = this.order
      const priceInput = this.order.price
      const currentPriceOrderObj = this.priceOrderLink[index]
      tempState = this.evaluatePriceInput(currentOrder, priceInput, currentPriceOrderObj)
      index += 1

      if (!tempState) isAllGood = false

      return isAllGood
    },

    evaluatePriceInput (order, priceInput, maxPriceOrderLink) {
      let maxOrderId = maxPriceOrderLink.orderId
      const orderNumber = this.orderId

      if (orderNumber !== maxOrderId) {
        console.log('Error, order mismatch', order, orderNumber, maxOrderId)
        return
      }

      let maxPrice = this.calculateMaxInputPrice(order)
      priceInput = Number(parseFloat(priceInput).toFixed(2))

      if (priceInput === '' || isNaN(priceInput)) {
        this.setPriceOrderClass(orderNumber, maxPrice, 'price/no-input')
        return false
      } else if (priceInput < 0) {
        this.setPriceOrderClass(orderNumber, maxPrice, 'price/no-negative')
        return false
      } else if ((maxPrice === 0 || maxPrice === '' || typeof maxPrice === 'undefined') && priceInput <= 0) {
        this.setPriceOrderClass(orderNumber, maxPrice, 'price/no-max-price')
        this.updateOrderPrice(priceInput) // Updates the order's price because we never actually touch the order's price
        return true
      } else if (priceInput > maxPrice) {
        this.setPriceOrderClass(orderNumber, maxPrice, 'price/too-high')
        return false
      } else if (priceInput !== '' && priceInput <= maxPrice) {
        this.setPriceOrderClass(orderNumber, maxPrice, 'price/perfect')
        this.updateOrderPrice(priceInput) // Updates the order's price because we never actually touch the order's price
        return true
      } else console.log('wtf', priceInput, maxPrice)
    },

    setPriceOrderClass (orderNumber, maxPrice, caseType) {
      if (!this.isSetCssFeedback) return

      switch (caseType) {
        case 'price/no-input':
          console.log('No price', orderNumber)
          document.getElementById('price' + orderNumber).className += ' red-border '
          this.feedbackMessage = this.$t('OrderCurrent.order') + ' #' + orderNumber + this.$t('OrderCurrent.modal.dispatch.no_price')
          break

        case 'price/no-negative':
          console.log('No negative price')
          document.getElementById('price' + orderNumber).className += ' red-border '
          this.feedbackMessage = this.$t('OrderCurrent.order') + ' #' + orderNumber + this.$t('OrderCurrent.modal.dispatch.no_negative')
          break

        case 'price/too-high':
          console.log('Input is higher', maxPrice)
          document.getElementById('price' + orderNumber).className += ' red-border '
          this.feedbackMessage = this.$t('OrderCurrent.order') + ' #' + orderNumber + this.$t('OrderCurrent.modal.dispatch.too_high') + ' (Max: ' + (maxPrice || 0) + '$)'
          break

        case 'price/no-max-price':
          console.log('No max price', maxPrice)
          document.getElementById('price' + orderNumber).className += ' green-border '
          break

        case 'price/perfect':
          console.log('Good price', maxPrice)
          document.getElementById('price' + orderNumber).className += ' green-border '
          break

        default:
          break
      }
    },

    updateOrderPrice (priceInput) {
      this.order.price = priceInput
    },

    onResendConfirmationEmail () {
      db.ref('database').child('transporter').child(this.companyUID).child('user').child('employees').child(this.chauffeurUid).child('infos').child('email').once('value').then((snap) => {
        db.ref('dispatchToSend').child(this.companyUID).child(this.orderId).child(this.historyKey).set(snap.val())
        this.reinitializeData()
      })
    },

    onRegenerateInvoice () {
      db.ref('dispatchQueue').child(this.companyUID).child(this.orderId).child(this.historyKey).set(this.randomPdfString(12))
    },

    randomPdfString (length) {
      var text = ''
      var possible = 'abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
      }
      return text + '.pdf'
    },

    reinitializeData () {
      this.feedbackMessage = ''
      this.closeModal()
    },

    closeModal () {
      this.$emit('closeModal')
    }
  },

  computed: {
    deliveryInvoice () {
      return this.entry.invoice
    },

    chauffeurUid () {
      return this.entry.chauffeur
    },

    uid () {
      return this.$store.state.user.uid
    },

    companyUID () {
      return this.$store.state.authorization.company
    },

    returnDbPath () {
      let dbPath = ''

      if (this.isOrderArchived) dbPath = dbArchives2.ref('database/transporter/' + this.companyUID + '/deliveries/' + this.orderId + '/historySync/' + this.historyKey)
      else dbPath = db.ref('database/transporter/' + this.companyUID + '/history/' + this.orderId + '/' + this.historyKey)

      return dbPath
    }
  }
}
</script>

<style>
  .dispatch-info-tab {
    display: flex;
    flex-flow: row;
  }
</style>
